import { sanitizeHtml } from '@/utils/safeHtml';

function applySafeHtml(el, value) {
  el.innerHTML = sanitizeHtml(value);
}

export const vSafeHtml = {
  beforeMount(el, binding) {
    applySafeHtml(el, binding.value);
  },
  updated(el, binding) {
    if (binding.value === binding.oldValue) return;
    applySafeHtml(el, binding.value);
  },
};

